<template>
    <span @click="go" class="back"> <span class="icon"></span> <span class="text">返回</span></span>
</template>
<script>
export default {
    props: {
        target: {
            type: String
        }
    },
    methods: {
        go() {
            if (this.target) {
                this.$router.replace(this.target)
            } else {
                this.$router.back()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// Back.vue?00863c7a